module.exports = __webpack_public_path__ + "static/media/dansk-k.3fccf4b3.mp3";